module.exports = __webpack_public_path__ + "img/DSpecial.e9edd55b.jpg";